export const getSelectedProducts = ({ selected_products }) => selected_products

export const getAdditionalInfo = ({ steps }) => steps?.additional_info;